import { render } from "./booksPackage.vue?vue&type=template&id=3fdf70dc&scoped=true"
import script from "./booksPackage.vue?vue&type=script&lang=js"
export * from "./booksPackage.vue?vue&type=script&lang=js"

import "./booksPackage.vue?vue&type=style&index=0&id=3fdf70dc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fdf70dc"]])

export default __exports__